import { handleResponseOld, makeGet } from './helpers';

const transform = (response: any = {}) => {
    return {
        data: {
            conversions: response.payload,
        },
        error: response.error,
    };
};

/**
 * @category Currency API
 * @see fetchCurrencyConversions
 */
type FetchCurrencyConversionsParams = {
    authToken?: string;
    deployment: string;
};
/**
 * Fetches currency conversion data from the Currency API
 * @function fetchCurrencyConversions
 * @category Currency API
 * @param {FetchCurrencyConversionsParams}
 * @see https://api.liveauctioneers.com/currency/
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/lgpcenbuwf/resources/oypsmh/methods/GET
 * @see https://github.com/LIVEauctioneers/quickchange/tree/master/functions/QuickchangeGetCurrencies
 */
const fetchCurrencyConversions = ({ authToken, deployment }: FetchCurrencyConversionsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<CURRENCY-API>' });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                transform,
            })
        );
    });

export default {
    fetchCurrencyConversions,
};
